import React, { useEffect, useState, useMemo, useCallback } from "react";
import DataTable from "react-data-table-component";
import { http } from "../helper";
import { BaseUrl } from "../common/config";
import DatePicker from "react-datepicker";
import Popup from "../common/popup";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";
import { dateformatwithuktime } from "../utilityfunctions";

export const CustomerWisefavouritedReport = ({}) => {
  const [popupView, setPopupView] = useState(false);
  const [loading, setLoading] = useState(false);
  const [customerDetails, setCustomerDetails] = useState({});
  const [favouriteItems, setFavouriteItems] = useState([]);
  const { t } = useTranslation();
  // Format price with currency symbol and two decimal places
  const priceFormat = (price) => {
    if (price === null || price === undefined) return "-";
    return Number(price).toLocaleString("en-US", {
      style: "currency",
      currency: "GBP",
      minimumFractionDigits: 2,
    });
  };
  const priceFormatCb = useCallback((price) => priceFormat(price), []);

  const customStyles = {
    rows: { style: { minHeight: "25px" } },
    headCells: { style: { padding: "8px" } },
    cells: { style: { padding: "8px" } },
  };

  const str_replace = (product_name) => {
    if (!product_name) return product_name;
    product_name = product_name.replaceAll("amp;", "&");
    product_name = product_name.replaceAll("apos;'", "'' ");
    product_name = product_name.replaceAll("quot;'", "'' ");
    return product_name;
  };
  const strReplaceCb = useCallback((name) => str_replace(name), []);

  var currentTime = new Date();
  var currentyear = currentTime.getFullYear();
  var currentMonth = currentTime.getUTCMonth() + 1;
  const [filter, setFilter] = useState(0);
  const [filtertext, setFilterText] = useState("");
  const [favouriteReport, setFavouriteReport] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);

  const getCurrentFiscalYear = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth() + 1;
    const startYear = month >= 9 ? year : year - 1;
    const endYear = startYear + 1;
    return `${startYear}-${endYear}`;
  };
  const [period, setPeriod] = useState(getCurrentFiscalYear());
  const [months, setMonths] = useState("9");
  const [quarter, setQuarter] = useState("");

  const MonthNames = [
    t("months.sep"),
    t("months.oct"),
    t("months.nov"),
    t("months.dec"),
    t("months.jan"),
    t("months.feb"),
    t("months.mar"),
    t("months.apr"),
    t("months.may"),
    t("months.jun"),
    t("months.jul"),
    t("months.aug"),
  ];

  const quarterNames = {
    1: t("quarter_sep_nov"),
    2: t("quarter_dec_feb"),
    3: t("quarter_mar_may"),
    4: t("quarter_jun_aug"),
  };

  const getCurrentFiscalQuarter = () => {
    const month = new Date().getMonth() + 1;
    if (month >= 9 && month <= 11) return 1;
    if (month === 12 || month <= 2) return 2;
    if (month >= 3 && month <= 5) return 3;
    return 4;
  };

  const getAvailableQuarters = (selectedFiscalYear) => {
    const currentFiscalYear = getCurrentFiscalYear();
    const currentQuarter = getCurrentFiscalQuarter();
    return Object.entries(quarterNames)
      .filter(([quarterNumber]) => {
        if (selectedFiscalYear === currentFiscalYear) {
          return Number(quarterNumber) <= currentQuarter;
        }
        return true;
      })
      .map(([quarterNumber, label]) => (
        <option key={quarterNumber} value={quarterNumber}>
          {label}
        </option>
      ));
  };

  useEffect(() => {
    const now = new Date();
    const month = now.getMonth() + 1;
    const fiscalQuarterMap = {
      9: 1,
      10: 1,
      11: 1,
      12: 2,
      1: 2,
      2: 2,
      3: 3,
      4: 3,
      5: 3,
      6: 4,
      7: 4,
      8: 4,
    };
    setQuarter(String(fiscalQuarterMap[month]));
  }, []);
  // Fetch the favourite-report summary based on the selected filter/date range
  useEffect(() => {
    setIsLoading(true);
    if (filter === "custom" && (!fromDate || !toDate)) {
      setIsLoading(false);
      return;
    }
    let payload = {};
    if (filter === "custom") {
      payload = {
        filter: filter,
        datefrom: format(new Date(fromDate), "yyyy-MM-dd"),
        dateto: format(new Date(toDate), "yyyy-MM-dd"),
      };
      setShowDatePicker(false);
    } else if (["weekly", "monthly", "quarterly", "FYdata"].includes(filter)) {
      payload = { filter: filter, datefrom: "", dateto: "", period: period };
    } else {
      // "all", "30", "90", "180", "365"
      payload = { filter: parseInt(filter), datefrom: "", dateto: "" };
    }
    let URL2 = BaseUrl + "admin/customer-wise-favourite-report";
    http
      .post(URL2, payload)
      .then((response) => {
        setIsLoading(false);
        const responseData = response.data.data || [];
        const actualMonth = parseInt(months);
        const updatedData1 =
          filter === "monthly"
            ? responseData.filter((item) => item.month === actualMonth)
            : filter === "quarterly"
              ? responseData.filter((item) => item.quarter === Number(quarter))
              : responseData;
        setFavouriteReport(updatedData1);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
  }, [filter, fromDate, toDate, months, quarter, period]);
  // Fetch favourite product details for a specific customer and show them in a popup
  const viewFavouriteItems = useCallback(
    (row) => {
      setCustomerDetails({
        accountCode: row.accountCode,
        accountName: row.accountName,
        accountEmail: row.accountEmail,
        accountPriceListId: row.accountPriceListId
      });
      setLoading(true);
      setFavouriteItems([]);
      setPopupView(true);
      const detailsPayload = { accountCode: row.accountCode, filter, accountPriceListId: row.accountPriceListId, };
      if (filter === "monthly") {
        detailsPayload.month = row.month;
        detailsPayload.year = row.year;
      } else if (filter === "quarterly") {
        detailsPayload.quarter = row.quarter;
        detailsPayload.fiscalYear = row.fiscalYear;
      } else if (filter === "FYdata") {
        detailsPayload.fiscalYear = row.fiscalYear;
      } else if (filter === "custom") {
        detailsPayload.datefrom = format(fromDate, "yyyy-MM-dd");
        detailsPayload.dateto = format(toDate, "yyyy-MM-dd");
      }
      const URL = BaseUrl + "admin/customer-wise-favourite-report/details";
      http
        .post(URL, detailsPayload)
        .then((response) => {
          setFavouriteItems(response?.data?.data || []);
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        });
    },
    [filter, fromDate, toDate],
  );

  const columns = useMemo(
    () => [
      {
        name: t("account_code_txt"),
        selector: (row) => row.accountCode,
        sortable: true,
      },
      {
        name: t("account_name_txt"),
        selector: (row) => row.accountName,
        sortable: true,
      },
      {
        name: t("email_address_txt"),
        selector: (row) => row.accountEmail,
        sortable: true,
      },
      {
        name: t("price_band_txt"),
        selector: (row) => row.accountPriceListId,
        sortable: true,
      },
      {
        name: t("no_of_favourite_products_txt"),
        selector: (row) => (
          <a
            className="title-tooltip title-up button"
            data-title={t("view_items_txt")}
            style={{ color: "white" }}
            onClick={() => viewFavouriteItems(row)}
          >
            {row.favouriteCount}
          </a>
        ),
        sortable: true,
      },
    ],
    [t, viewFavouriteItems],
  );

  const paginationComponentOptions = {
    rowsPerPageText: "",
    rangeSeparatorText: "",
    selectAllRowsItem: true,
    selectAllRowsItemText: "",
    noRowsPerPage: "",
  };

  const changeFilterHandler = useCallback((e) => {
    const val = e.target.value;
    setFilter(val);
    setFilterText(e.target.options[e.target.selectedIndex].text);
    if (val === "custom") {
      setShowDatePicker(true);
    } else {
      setShowDatePicker(false);
      setFromDate(null);
      setToDate(null);
    }
  }, []);

  const changePeriodHandler = useCallback(
    (e) => {
      const newPeriod = e.target.value;
      setPeriod(newPeriod);
      const fiscalStartMonthIndex = 8;
      const today = new Date();
      const currentFiscalYear = getCurrentFiscalYear();
      const isCurrentFiscalYear = newPeriod === currentFiscalYear;
      if (filter === "monthly") {
        let visibleMonthNames = MonthNames;
        if (isCurrentFiscalYear) {
          const currentMonthIndex = today.getMonth();
          const monthsPassedSinceFiscalStart =
            (currentMonthIndex - fiscalStartMonthIndex + 12) % 12;
          visibleMonthNames = MonthNames.slice(
            0,
            monthsPassedSinceFiscalStart + 1,
          );
        }
        const selectedMonthIndex = MonthNames.indexOf(months);
        const isValidMonth =
          selectedMonthIndex >= 0 &&
          selectedMonthIndex < visibleMonthNames.length;
        if (!isValidMonth) {
          const defaultMonthNumber = ((0 + fiscalStartMonthIndex) % 12) + 1;
          setMonths(String(defaultMonthNumber));
        }
      }
      if (filter === "quarterly") {
        const currentQuarter = getCurrentFiscalQuarter();
        let maxQuarter = isCurrentFiscalYear ? currentQuarter : 4;
        if (parseInt(quarter) > maxQuarter) {
          setQuarter(maxQuarter > 0 ? String(maxQuarter) : "1");
        }
      }
    },
    [filter, MonthNames, quarter, months],
  );

  const changeMonthHandler = useCallback((e) => {
    setMonths(e.target.value);
  }, []);

  const formatDate = useCallback((dateString) => {
    const dateObject = new Date(dateString);
    const year = dateObject.getFullYear();
    const month = String(dateObject.getMonth() + 1).padStart(2, "0");
    const day = String(dateObject.getDate()).padStart(2, "0");
    return `${day}/${month}/${year}`;
  }, []);

  const DateChange = useCallback(
    (value, type) => {
      if (type === "from") {
        setFromDate(value);
        if (toDate && value && value > toDate) {
          setToDate(null);
        }
      } else if (type === "to") {
        if (!fromDate || value >= fromDate) {
          setToDate(value);
        } else {
          setToDate(null);
        }
      }
    },
    [fromDate, toDate],
  );

  const calculatePaginationOptions = useCallback((totalRecords, interval) => {
    const opts = [];
    for (let i = interval; i <= totalRecords; i += interval) {
      opts.push(i);
    }
    return opts;
  }, []);

  const totalRecords = favouriteReport.length;
  const paginationOptions = useMemo(
    () => calculatePaginationOptions(totalRecords, 10),
    [totalRecords, calculatePaginationOptions],
  );

  const options = useMemo(() => {
    const arr = [];
    for (let i = currentyear; i >= 2023; i--) {
      if (i === currentyear && currentMonth < 9) continue;
      const year = i;
      arr.push(
        <option key={year} value={year + "-" + (year + 1)}>
          {year + "-" + (year + 1)}
        </option>,
      );
    }
    return arr;
  }, [currentyear, currentMonth]);

  const currentFiscalYear = getCurrentFiscalYear();
  let visibleMonthNames = MonthNames;
  if (period === currentFiscalYear) {
    const fiscalIndex = (new Date().getMonth() - 8 + 12) % 12;
    visibleMonthNames = MonthNames.slice(0, fiscalIndex + 1);
  }

  let loadingbuffer = isLoading ? "loading-buffer" : "";

  return (
    <div
      className={`chart-container chart-customer-wise-favourite-report ${loadingbuffer}`}
      style={{ verticalAlign: "top" }}
    >
      <div className="chart-Hdr">
        <div className="chart-Hdr-txt">
          <h2>{t("customer_wise_favourite_products_txt")}</h2>
        </div>
        <div
          className="chart-fltr"
          onMouseEnter={() => {
            if (filter === "custom" && !showDatePicker) setShowDatePicker(true);
          }}
          onMouseLeave={() => {
            if (filter === "custom" && showDatePicker) setShowDatePicker(false);
          }}
        >
          <select value={filter} onChange={(e) => changeFilterHandler(e)}>
            <option value={0}>{t("all_txt")}</option>
            <option value={"weekly"}>{t("current_week_txt")}</option>
            <option value={"monthly"}>{t("monthly_txt")}</option>
            <option value={"quarterly"}>{t("quarterly_txt")}</option>
            <option value={"FYdata"}>{t("fy_data_txt")}</option>
            <option value={30}>{t("past_30_days_txt")}</option>
            <option value={90}>{t("past_90_days_txt")}</option>
            <option value={180}>{t("past_180_days_txt")}</option>
            <option value={365}>{t("past_1_year_txt")}</option>
            <option value={"custom"}>{t("custom_date_txt")}</option>
          </select>
          {showDatePicker && (
            <div className="date-picker-container">
              <label>{t("from_txt")}:</label>
              <DatePicker
                selected={fromDate}
                onChange={(date) => DateChange(date, "from")}
                showDisabledMonthNavigation
                dateFormat="dd/MM/yyyy"
                disablePast={true}
                maxDate={new Date()}
                placeholderText={t("select_date_txt")}
              />
              <label>{t("to_txt")}:</label>
              <DatePicker
                selected={toDate}
                showDisabledMonthNavigation
                dateFormat="dd/MM/yyyy"
                onChange={(date) => DateChange(date, "to")}
                disablePast={true}
                maxDate={new Date()}
                placeholderText={t("select_date_txt")}
              />
            </div>
          )}
          {filter === "quarterly" && (
            <select
              value={quarter}
              onChange={(e) => setQuarter(e.target.value)}
            >
              {getAvailableQuarters(period)}
            </select>
          )}
          {filter === "monthly" && (
            <select value={months} onChange={(e) => changeMonthHandler(e)}>
              {visibleMonthNames.map((monthName, index) => {
                const monthNumber = ((index + 8) % 12) + 1;
                return (
                  <option key={monthNumber} value={monthNumber}>
                    {monthName}
                  </option>
                );
              })}
            </select>
          )}
          {(filter === "monthly" ||
            filter === "quarterly" ||
            filter === "FYdata") && (
            <select value={period} onChange={(e) => changePeriodHandler(e)}>
              {options}
            </select>
          )}
        </div>
        <div className="fltr-sub-val">
          {favouriteReport.length > 0 && (
            <span className="fltr-val">
              {t("total_records")?.replace("{{count}}", favouriteReport.length)}{" "}
              {[
                t("current_week_txt"),
                t("monthly_txt"),
                t("quarterly_txt"),
                t("fy_data_txt"),
              ].includes(filtertext)
                ? ""
                : filtertext !== "" && filtertext !== t("custom_date_txt")
                  ? " (" + filtertext + ")"
                  : filtertext === t("custom_date_txt") && fromDate && toDate
                    ? " (" +
                      formatDate(fromDate) +
                      " - " +
                      formatDate(toDate) +
                      ")"
                    : " (" + t("all_txt") + ")"}
            </span>
          )}
        </div>
      </div>
      <DataTable
        columns={columns}
        data={favouriteReport}
        customStyles={customStyles}
        noDataComponent={
          <div className="no-records-found">
            {t("no_data_filtered_search_txt")}
          </div>
        }
        pagination
        paginationPerPage={10}
        paginationRowsPerPageOptions={[10, 20, 40, 60, 80, 100]}
        paginationComponentOptions={paginationComponentOptions}
      />
      {popupView && (
        <Popup
          extClass="order-pop customer-wise-favourite-details-pop popup-wrap-sm"
          headMoreTxt={
            <div className="order-top">
              <div className="bottom order-flex">
                <div className="order_account_details abandoned-cart-left">
                  <p>
                    {t("account_name_txt")}:{" "}
                    <span className="date">
                      {customerDetails.accountName}
                    </span>{" "}
                  </p>
                  <p>
                    {t("account_code_txt")}:{" "}
                    <span className="date">
                      {customerDetails.accountCode}
                    </span>{" "}
                  </p>
                </div>
                <div className="order_account_details abandoned-cart-left">
                <p>
                    {t("email_address_txt")}:{" "}
                    <span className="pay">{customerDetails.accountEmail}</span>
                  </p>
                  <p>
                    {t("price_band_txt")}:{" "}
                    <span className="pay">{customerDetails.accountPriceListId}</span>
                  </p>
                </div>

              </div>
            </div>
          }
          closebtn={
            <div className="pop-header-top order-top">
              <div className="head">
                <h4>{t("favourite_products_details_txt")}</h4>
              </div>
              <span
                onClick={() => setPopupView(false)}
                className="close"
              ></span>
            </div>
          }
          bodyMoreTxt={
            <div className="modal-table">
              <h4 className="item-title">{t("favourite_items_txt")}</h4>
              {loading && (
                <div className="loading-overlay">
                  <div className="loading-message">{t("loading_txt")}</div>
                </div>
              )}
              {!loading && (
                <div className="checkout-table">
                  <div className="table_overflow">
                    <table>
                      <thead>
                        <tr>
                          <td>{t("product_txt")}</td>
                          <td>{t("unit_of_sale_txt")}</td>
                          <td>{t("item_added_on_txt")}</td>
                          <td>{t("price_txt")}</td>
                        </tr>
                      </thead>
                      <tbody>
                        {favouriteItems.length > 0 &&
                          favouriteItems.map((item, index) => (
                            <tr key={index}>
                              {/* Product */}
                              <td 
                                data-title={t("product_txt")}
                                className="data-product-hide"
                              >
                                <div className="product-with-tooltip">
                                  {strReplaceCb(item.productDescription)} (
                                    {item.productNumber?.includes("_")
                                      ? item.productNumber.substring(
                                          0,
                                          item.productNumber.indexOf("_"),
                                        )
                                      : item.productNumber}
                                  ){" "}
                                  <a
                                    className="title-tooltip title-right"
                                    // data-title={
                                    //   item.categoryId === "1"
                                    //     ? t("categories.pizza")
                                    //     : ["10", "11", "12", "13"].includes(item.categoryId)
                                    //       ? t("categories.pasta_rice_noodle_sauces")
                                    //       : item.categoryId === "14"
                                    //         ? t("categories.desserts")
                                    //         : ""
                                    // }
                                    data-title={
                                      item.categoryId === "1"
                                        ? t("categories.pizza")
                                        : ["10", "13"].includes(item.categoryId)
                                          ? "PASTA, RICE & NOODLE SAUCES"
                                          : ["11", "12"].includes(item.categoryId)
                                            ? "BURRITO"
                                          : item.categoryId === "14"
                                            ? t("categories.desserts")
                                            : ""
                                    }
                                  >
                                    <i className="fa fa-th-list" aria-hidden="true"></i>
                                  </a>
                                </div>
                              </td>
                              {/* Unit of Sale */}
                              <td data-title={t("unit_of_sale_txt")}>
                                {item.packageSize}
                              </td>
                              <td>
                                {dateformatwithuktime(item.createdAt)}
                              </td>
                              {/* Unit of Sale */}
                              <td data-title={t("price_txt")}>
                                {priceFormatCb(item.productPrice)}
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>
          }
        />
      )}
    </div>
  );
};
